import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import App from './App';
import { theme } from './theme';

import './fonts.css';
import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dropzone/styles.css';
import './index.css';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/de';

// Ohne dieses Plugin ignoriert dayjs sein Format-Argument vollstaendig. Mantines
// `defaultDateParser` ruft `dayjs(eingabe, valueFormat, locale)` auf und faellt bei
// `Invalid Date` auf `new Date(eingabe)` zurueck -- das kennt kein deutsches Datumsformat und
// liest "01.02.2030" als MM.DD.YYYY, also als 2. Januar. Getippter 1. Februar, gespeicherter
// 2. Januar, ohne Fehlermeldung und ohne dass das Feld es anzeigt. Betrifft jedes DateInput der
// Anwendung, nicht nur ein einzelnes Formular.
dayjs.extend(customParseFormat);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <MantineProvider theme={theme}>
        <ModalsProvider>
          <DatesProvider settings={{ locale: 'de' }}>
            <Notifications position="top-right" />
            <App />
          </DatesProvider>
        </ModalsProvider>
      </MantineProvider>
    </BrowserRouter>
  </StrictMode>
);
